import api from "./api";

const SETTINGS_BASE_PATH = "/api/settings";
const withBasePath = (suffix = "") => `${SETTINGS_BASE_PATH}${suffix}`;

/**
 * Chat Settings API
 */
export const getChatSettings = () => api.get(withBasePath("/chat"));
export const updateChatSettings = (data: Record<string, unknown>) =>
  api.put(withBasePath("/chat"), data);

/**
 * NLP Settings API
 */
export const getNLPSettings = () => api.get(withBasePath("/nlp"));
export const updateNLPSettings = (data: Record<string, unknown>) =>
  api.put(withBasePath("/nlp"), data);

/**
 * Sync Logs API
 */
export const getSyncLogs = () => api.get(withBasePath("/sync-logs"));

/**
 * Rista configuration API
 */
export const getRistaConfig = () => api.get(withBasePath("/rista"));
export const updateRistaConfig = (data: { branch: string; channel: string }) =>
  api.put(withBasePath("/rista"), data);

/**
 * LLM Prompts API (Super Admin Only)
 */
export const getLLMPrompts = () => api.get(withBasePath("/llm-prompts"));
export const updateLLMPrompts = (data: {
  interpretationPrompt?: string | null;
  structuredResponsePrompt?: string | null;
}) => api.put(withBasePath("/llm-prompts"), data);
export const resetLLMPrompts = () => api.post(withBasePath("/llm-prompts/reset"), {});

/**
 * Image Upload Settings API (Super Admin Only)
 */
export const getImageUploadSettings = () => api.get(withBasePath("/image-upload"));
export const updateImageUploadSettings = (data: {
  image_default_width?: number;
  image_default_height?: number;
  image_max_size_bytes?: number;
  allowed_formats?: string[];
}) => api.put(withBasePath("/image-upload"), data);

/**
 * Company Profile API (Super Admin Only)
 */
export const getCompanyProfile = () => api.get(withBasePath("/company-profile"));
export const updateCompanyProfile = (data: {
  name: string;
  shortTagline?: string | null;
  aboutHtml?: string | null;
  facts?: any;
}) => api.put(withBasePath("/company-profile"), data);

/**
 * Carousel Settings API
 */
export const getCarouselSettings = () => api.get(withBasePath("/carousel"));
export const updateCarouselSettings = (data: { max_items: number }) =>
  api.put(withBasePath("/carousel"), data);

